import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const APP_NAME = "Azex Audit";

// Route pathname → page title. Uses startsWith so nested/child routes still match.
const ROUTE_TITLES = [
  ["/login", "Login"],
  ["/register", "Register"],
  ["/accept-invite", "Accept Invite"],
  ["/reset-password", "Reset Password"],
  ["/executive", "Executive Dashboard"],
  ["/engagements", "Engagements"],
  ["/gl-import", "GL Import"],
  ["/planning", "Planning"],
  ["/risk-assessment-forms", "Risk Assessment Forms"],
  ["/risk", "Risk Assessment"],
  ["/analytics", "Analytics"],
  ["/ratios", "Financial Ratios"],
  ["/aging", "Aging Analysis"],
  ["/sampling", "Sampling"],
  ["/vouching", "Vouching Sheet"],
  ["/documents", "Document Review"],
  ["/doc-summaries", "Document Summaries"],
  ["/discrepancies", "Discrepancy Report"],
  ["/ifrs", "IFRS Statements"],
  ["/completion", "Completion"],
  ["/assistant", "AI Audit Assistant"],
  ["/audit-trail", "Audit Trail"],
  ["/platform", "Platform Admin"],
  ["/settings", "Settings"],
  // Batch 6 · B (AT-5 / AT-54): the pages that fell back to "Dashboard"
  ["/methodology", "Methodology"], ["/acceptance", "Acceptance & Continuance"], ["/scoping", "Scoping"],
  ["/digital-audit", "Digital Audit"], ["/audit-response", "Audit Response Plan"], ["/controls/203a", "Control Design (203(a))"], ["/controls", "Controls"],
  ["/confirmations", "Confirmations"], ["/confirmations-forms", "Confirmations"], ["/head-folders", "Head Folders"],
  ["/fieldwork/a9001", "Journal Entry Testing"], ["/fieldwork/a9003", "Opening Balances"], ["/fieldwork/adjusting-entries", "Adjusting entries"], ["/cut-off", "Cut-off"],
  ["/cutoff", "Cut-off"], ["/completion/misstatements", "Misstatement worksheet"], ["/completion/summary-memo", "Audit summary memo"],
  ["/completion/clearance-gate", "Clearance gate"], ["/completion/eq-review", "Engagement Quality Review (522(a))"],
  ["/completion/kam-register", "KAM Register"], ["/completion/other-information", "Other Information"],
  ["/review-points", "Review Points"], ["/disclosure-checklist", "Disclosure Checklist"],
  ["/reporting/auditors-report", "Auditor's Report"], ["/reporting/firm-report-formats", "Firm Report Formats"],
  ["/close/file-assembly", "File assembly"], ["/verify-bundle", "Verify Signed Bundle"], ["/recycle-bin", "Recycle Bin"],
  ["/isqm", "ISQM"], ["/document-library", "Document Library"], ["/billing", "Billing / Over Run"], ["/ai-usage", "AI Usage"],
  ["/help", "Help Center"], ["/specialized", "Specialized"], ["/review", "Review engagement"],
];

export function pageTitleFor(pathname) {
  if (pathname === "/" || pathname === "") return "Dashboard";
  const match = ROUTE_TITLES.find(([prefix]) => pathname.startsWith(prefix));
  return match ? match[1] : "Dashboard";
}

/**
 * Mount once inside <BrowserRouter>. Sets document.title on every navigation
 * following the pattern "[Page] – Azex Audit".
 */
export default function PageTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = `${pageTitleFor(pathname)} – ${APP_NAME}`;
  }, [pathname]);

  return null;
}
